import styled from 'styled-components'
import { Theme } from 'styles/Themes'
import { IMaskInput } from 'react-imask'

interface IStyleProps {
  rounded?: boolean
  small?: boolean
  medium?: boolean
  large?: boolean
  icon?: boolean
  error?: string
  disabled?: boolean
}

export const MaskedInput = styled(IMaskInput)`
  position: ${(props: IStyleProps) => (props.icon ? 'relative' : 'inherit')};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  height: 40px;
  box-sizing: border-box;
  padding: 16px 0px 16px 16px;
  margin-left: 0.5px;
  transition: all 0.3s ease-out;
  height: 48px;
  outline: none;
  color: #424242;
  background: ${(props) =>
    props.disabled ? Theme.pallete.QUATERNARY : Theme.pallete.SECONDARY};
  border: 1px solid;
  border-color: ${(props) =>
    props.disabled
      ? Theme.pallete.QUATERNARY
      : props.error
      ? '#D61212'
      : '#cccccc'};
  &:hover {
    border-color: ${(props) =>
      props.disabled
        ? Theme.pallete.QUATERNARY
        : props.error
        ? '#B00000'
        : '#757575'};
  }
  &:disabled {
    color: rgb(84, 84, 84);
  }
  border-radius: ${(props: IStyleProps) => (props.rounded ? '30px' : '5px')};
  width: 100%;
  max-width: 100%;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const InputIcon = styled.img`
  width: ${(props: { icon: string }) => {
    if (props.icon === 'password') return '16px'
    return '20px'
  }};
  height: ${(props: { icon: string }) => {
    if (props.icon === 'password') return '16px'
    return '20px'
  }};
  filter: invert(48%) sepia(5%) saturate(92%) hue-rotate(98deg) brightness(93%)
    contrast(97%);
  position: absolute;
  right: 25px;
  top: 17px;
`

export const Loading = styled.div<{ loading: boolean | undefined }>`
  pointer-events: none;
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: ${(props) => (props.loading ? 'flex' : 'none')};
  .loading-img {
    width: 20px;
    @keyframes load {
      to {
        transform: rotate(360deg);
      }
    }
    animation: load 2s infinite linear;
  }
`
